
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.414 1.086L2 2.5l3.798 3.798C2.73 8.662 1.061 12 1.061 12s4 8 11 8c2.168 0 4.049-.768 5.612-1.827l3.419 3.419 1.414-1.414L3.414 1.086zm10.47 13.297l-4.206-4.205a3 3 0 004.206 4.206zM23.06 12s-.781 1.562-2.256 3.305L9.788 4.288A9.131 9.131 0 0112.06 4c7 0 11 8 11 8z"}})])
          )
        }
      }
    